/* eslint-disable no-invalid-this */

/**
 * Authenticates a user using the Habile flow.
 *
 * In Habile flow, fetchNeonApiTokenAndUser is called directly with just the token.
 *
 * @param {Object} credentials - Expected to have an `idToken` property.
 * @returns {Promise<Object>} - Resolves with the authenticated user object.
 */
export function authenticate(credentials) {
    return this.fetchNeonApiTokenAndUser(credentials.idToken)
        .then(user => user)
        .catch(error => {
            this.logger.error({
                message: 'Unsuccessful Habile API token exchange (Habile)',
                error,
                component: 'neonAuth'
            });
            return Promise.reject(error);
        });
}
